import { Button } from '@mm/components';
import { CloseIcon } from '@mm/icons';
import { EspDomainType } from '@mm/state/model/EspModel';
import { selectCurrentUser } from '@mm/state/selectors/userSelector';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { EmailInput } from '../InviteUserModal/EmailInput/EmailInput';
import { CloseModalProps } from '../modal-helpers';
import dataprotectionIcon from './dataprotection.svg';
import styles from './VerifyEmailModal.module.css';

export const VerifyEmailModal = (props: CloseModalProps) => {
  const { closeModal } = props;
  const { email = '' } = useSelector(selectCurrentUser) || {};
  const [resendEmail, setResendEmail] = useState('');
  const [showResend, setShowResend] = useState(false);

  return (
    <div className={styles.container}>
      <CloseIcon
        className={styles.closeIcon}
        onClick={closeModal}
        color="#262626"
      />
      <img src={dataprotectionIcon} className={styles.logo} />
      <div className={styles.descriptionContainer}>
        <div className={styles.heading}> Check Your Email</div>
        <div className={classNames(styles.description, styles.alignCenter)}>
          Click a link in the message we've sent to{' '}
          <span className={styles.email}>{email} </span> to activate your
          account
        </div>
      </div>
      <div className={styles.descriptionContainer}>
        <div className={classNames(styles.description, styles.bold)}>
          Didn't get an email?
        </div>
        <div className={styles.description}>
          Step 1. Check your <span className={styles.bold}>Spam</span> folder
        </div>
        <div className={styles.description}>
          Step 2.{' '}
          <span
            className={classNames(
              classNames(styles.link, { [styles.blackLink]: showResend }),
            )}
            onClick={() => setShowResend(!showResend)}
          >
            Re-enter your email and try again
          </span>
        </div>
        {showResend && (
          <div className={styles.resendContainer}>
            <EmailInput
              defaultValue={resendEmail}
              onChange={payload => setResendEmail(payload.email)}
            />
            <Button
              css={{ container: styles.resendButton }}
              disabled={!resendEmail.length}
            >
              Re-send
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
